import { State } from 'interfaces/state'
import { useSelector, useDispatch, Dispatch, shallowEqual } from 'react-redux'
import { useMemo } from 'react'

// TODO find a way to implement it without additional function
// export const useStoreSelector: UseStoreSelector = useSelector
export const useStoreDispatch = useDispatch as <TAction>() => Dispatch<TAction>

export function useStoreSelector<TEntity> (
  selector: (state: State) => TEntity,
  equalityFn?: (left: TEntity, right: TEntity) => boolean
): TEntity {
  return useSelector(selector, equalityFn)
}

export function useShallowSelector<T> (selector: (state: State) => T) {
  return useSelector(selector, shallowEqual) as T
}

type SelectorType<C> =
  C extends () => infer S ?
    S extends (state: State, params: infer P) => infer R
      ? [S, R, P]
      : never
    : never

export function useSelectorWithDefaults<C extends (...args: any[]) => any, T extends SelectorType<C>, R extends T[1], P extends T[2], D extends Partial<R>> (create: C, props: P, defaults: D = {} as any) {
  const selector = useMemo(create, [create])
  return useShallowSelector((state) => ({
    ...defaults,
    ...selector(state, props) || {},
  })) as Partial<Exclude<R, null>> & D
}
